import styled, { css } from 'styled-components';
import { smRegular, xxsBold } from '../theme/typography';
import { themeColor } from '../theme/colors';

const BaseButton = styled.button<{ $size: 'xs' | 'sm' | 'md' }>`
  border-radius: 8px;

  ${({ $size }) => {
    if ($size === 'sm') {
      return css`
        ${xxsBold};
        padding: 4px 8px;
      `;
    }
    if ($size === 'xs') {
      return css`
        ${xxsBold};
        padding: 4px 8px;
      `;
    }
    return css`
      ${smRegular};
      padding: 10px 12px;
    `;
  }}

  display: inline-flex;
  align-items: center;
  gap: 8px;

  cursor: pointer;

  color: ${themeColor('textPrimary')};
`;

export const Outlined = styled(BaseButton)`
  border: 1px solid ${themeColor('strokePrimary')};
  background: ${themeColor('buttonBackground')};

  &:hover {
    background: ${themeColor('buttonBackgroundHover')};
  }

  &:active {
    background: ${themeColor('strokePrimary')};
  }

  &:disabled {
    pointer-events: none;
    border: ${themeColor('strokePrimary')};
    background: ${themeColor('backgroundLight')};

    color: ${themeColor('textTertiary')};
  }
`;

export const Glow = styled(BaseButton)`
  border: 1px solid transparent;
  background: ${themeColor('glowGradient')};
  color: ${themeColor('backgroundDark')};

  &:hover {
    box-shadow: ${themeColor('glowBoxShadow')};
  }

  &:active {
    background: ${themeColor('glowPressed')};
  }

  &:disabled {
    cursor: not-allowed;
    background: ${themeColor('buttonBackground')};
    border: 1px solid ${themeColor('strokePrimary')};
    color: ${themeColor('textTertiary')};

    &:hover {
      box-shadow: none;
    }
  }
`;

export const Solid = styled(Outlined)`
  border: 1px solid ${themeColor('buttonBackground')};
  background: ${themeColor('buttonBackground')};
`;

export const Text = styled(BaseButton)`
  border: none;
  background: none;
  border-radius: 0;
  padding: 0 2px;
  text-decoration: underline;

  opacity: 0.8;
  &:hover {
    opacity: 1;
  }
`;
